"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function dates_to_labels(analytics) {
    return [''].concat(analytics.map(function (analytic) {
        return storybook_1.Helpers.date_to_label(analytic.date);
    }));
}
function Graph(_a) {
    var dates = _a.dates, params = _a.params;
    var analytics = storybook_1.Hooks.useAnalytics(params);
    if (analytics.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Graphs.Container, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-4 text-center' }, dates.from === analytics.meta.sevendays.from && dates.till === analytics.meta.sevendays.till
            ? 'Laatste 7 dagen'
            : storybook_1.Helpers.date_to_label(dates.from, true) + " t/m " + storybook_1.Helpers.date_to_label(dates.till, true)),
        react_1.default.createElement(storybook_1.Graphs.Chart, { id: 'chart-2', settings: {
                // The type of chart we want to create
                type: 'line',
                // The data for our dataset
                data: {
                    labels: dates_to_labels(analytics.data),
                    datasets: [
                        {
                            label: 'Unieke weergaven',
                            backgroundColor: '#FF0062',
                            borderColor: '#FF0062',
                            data: [0].concat(analytics.data.map(function (analytic) { return analytic.views_unique; })),
                        },
                        {
                            label: 'Weergaven',
                            backgroundColor: '#A3AEBE',
                            borderColor: '#A3AEBE',
                            data: [0].concat(analytics.data.map(function (analytic) { return analytic.views; })),
                        },
                    ],
                },
                // Configuration options go here
                options: {
                    layout: {
                        padding: {
                            top: 20,
                        },
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        xPadding: 10,
                        yPadding: 10,
                        cornerRadius: 4,
                        displayColors: false,
                        backgroundColor: '#10083E',
                    },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 4,
                            hitRadius: 5,
                        },
                        line: {
                            tension: 0,
                            fill: false,
                        },
                    },
                    scales: {
                        xAxes: [{
                                display: true,
                                gridLines: {
                                    display: false,
                                },
                                ticks: {
                                    padding: 8,
                                },
                            }],
                        yAxes: [{
                                display: true,
                                gridLines: {
                                    display: true,
                                    drawBorder: false,
                                    zeroLineWidth: 0,
                                    drawTicks: false,
                                    color: '#e2e8f0',
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 20,
                                    precision: 0
                                },
                            }],
                    },
                },
            } }));
}
exports.default = Graph;
